import React, { useMemo } from 'react';
import { Layout } from 'fronton-react';
import { useStoreon } from 'storeon/react';
import { LinkBanner, RemoteCarouselWithBasket, RootLayout, SectionTitle } from 'common/components';
import { MODEL_JSON_STORE_NAME, SeasonStartModelJson, useRegionIdSelector } from 'modules/model-json';
import { convertProducts } from 'utils';
import { SeasonStartCategories } from './components/season-start-categories';
import {
  FENCES_CATEGORY,
  REGION_ID_LIST_WITHOUT_FENCES,
  SEASON_START_ELEMENT_BLOCK,
  SEASON_START_PATH,
  SEASON_START_SOLUTIONS_CATEGORIES,
} from './season-start-constants';

export const SeasonStart = () => {
  const { modelJson } = useStoreon(MODEL_JSON_STORE_NAME);
  const { offers, banners } = modelJson.model as SeasonStartModelJson;
  const regionId = useRegionIdSelector();
  const categories = useMemo(() => {
    if (REGION_ID_LIST_WITHOUT_FENCES.includes(regionId)) {
      return SEASON_START_SOLUTIONS_CATEGORIES;
    }

    return [
      SEASON_START_SOLUTIONS_CATEGORIES[0],
      {
        ...SEASON_START_SOLUTIONS_CATEGORIES[1],
        itemList: [
          ...SEASON_START_SOLUTIONS_CATEGORIES[1].itemList,
          FENCES_CATEGORY,
        ],
      },
    ];
  }, [regionId]);

  return (
    <RootLayout currentPage={SEASON_START_PATH} hideSeoText>
      <Layout>
        <SectionTitle size="extra">
          На старт, внимание, дача!
        </SectionTitle>
        <SeasonStartCategories
          categoryList={categories}
          elementBlock={SEASON_START_ELEMENT_BLOCK}
        />
      </Layout>

      {offers?.[0] && (
        <RemoteCarouselWithBasket
          elementBlock={SEASON_START_ELEMENT_BLOCK}
          productIdList={convertProducts(offers?.[0].products)}
          remoteId="remote-carousel-0"
          seeMoreLink={offers?.[0].link}
          showSeeMore
          title={offers?.[0].title}
        />
      )}

      {offers?.[1] && (
        <RemoteCarouselWithBasket
          elementBlock={SEASON_START_ELEMENT_BLOCK}
          productIdList={convertProducts(offers?.[1].products)}
          remoteId="remote-carousel-1"
          seeMoreLink={offers?.[1].link}
          showSeeMore
          title={offers?.[1].title}
        />
      )}

      {banners?.[0]?.images[0] && (
        <Layout>
          <LinkBanner
            banner={{
              alt: banners[0].images[0].gaName,
              srcLd: banners[0].images[0].photoLinkDesktop,
              srcD: banners[0].images[0].photoLinkDesktop,
              srcT: banners[0].images[0].photoLinkTablet,
              src: banners[0].images[0].photoLinkMobile,
            }}
            elementBlock={SEASON_START_ELEMENT_BLOCK}
            elementName={banners[0].images[0].gaName}
            href={banners[0].images[0].pathLink}
            title={banners[0].images[0].offerName}
          />
        </Layout>
      )}

      {offers?.[2] && (
        <RemoteCarouselWithBasket
          elementBlock={SEASON_START_ELEMENT_BLOCK}
          productIdList={convertProducts(offers?.[2].products)}
          remoteId="remote-carousel-2"
          seeMoreLink={offers?.[2].link}
          showSeeMore
          title={offers?.[2].title}
        />
      )}

      {banners?.[1]?.images[0] && (
        <Layout>
          <LinkBanner
            banner={{
              alt: banners[1].images[0].gaName,
              srcLd: banners[1].images[0].photoLinkDesktop,
              srcD: banners[1].images[0].photoLinkDesktop,
              srcT: banners[1].images[0].photoLinkTablet,
              src: banners[1].images[0].photoLinkMobile,
            }}
            elementBlock={SEASON_START_ELEMENT_BLOCK}
            elementName={banners[1].images[0].gaName}
            href={banners[1].images[0].pathLink}
            title={banners[1].images[0].offerName}
          />
        </Layout>
      )}

      {offers?.[3] && (
        <RemoteCarouselWithBasket
          elementBlock={SEASON_START_ELEMENT_BLOCK}
          productIdList={convertProducts(offers?.[3].products)}
          remoteId="remote-carousel-3"
          seeMoreLink={offers?.[3].link}
          showSeeMore
          title={offers?.[3].title}
        />
      )}
    </RootLayout>
  );
}
